import {Router} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class BuildingHelperService {
  constructor(private router: Router) {}

  public getBuildingId(): string {
    return this.router.url.split('/')[2];
  }

  public getInspectionId(): string {
    return this.router.url.split('/')[4];
  }
}

